import capitalize from "lodash/capitalize";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Type } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import type { EnrichedRecent } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useEnrichedRecents";
import CompanyQuotaIndicator from "app/pages/sales-intelligence/modules/quota/components/CompanyQuotaIndicator/CompanyQuotaIndicator";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import homePageTrackingService from "app/pages/sales-intelligence/services/tracking/home-page/trackingService";

import { StyledRecentItem, StyledRecentItemIcon } from "./styles";

const RecentItem = ({
    recent,
    isDisabled,
    isSuggestion,
    isDataCreditsEnabled,
}: {
    recent: EnrichedRecent;
    isDisabled: boolean;
    isSuggestion: boolean;
    isDataCreditsEnabled: boolean;
}) => {
    const { id, data, companyData } = recent;
    const name = data.resources?.companyName || data.mainItem;

    const handleItemClick = () => {
        if (isDisabled) {
            return;
        }
        if (data.type === "company") {
            homePageTrackingService.trackRecentCompanyClicked(name, isSuggestion);
            void siNavigator.goToCompanyAnalysisOverviewPage(data.mainItem);
        } else {
            homePageTrackingService.trackRecentDomainClicked(name, isSuggestion);
            void siNavigator.goToWebsiteAnalysisPerformancePage({
                key: data.mainItem,
                isWWW: "*",
                duration: "3m",
                country: 999,
            });
        }
    };

    return (
        <StyledRecentItem
            className=""
            primaryText={name}
            onItemClick={handleItemClick}
            isDisabled={isDisabled}
            iconComponent={
                <StyledRecentItemIcon
                    iconType={Type.Website}
                    iconSrc={data.resources?.mainItemFavIcon || ""}
                />
            }
            actionItems={[
                <CompanyQuotaIndicator
                    key={`quota-tag-${id}`}
                    isDataCreditsEnabled={isDataCreditsEnabled}
                    isLocked={isDisabled}
                    isPurchased={companyData?.isPurchased}
                />,
                <Flex
                    alignItems="center"
                    justifyContent="flex-end"
                    gap="4px"
                    key={`action-${id}`}
                    minWidth="100px"
                >
                    <SWReactIcons
                        iconName={data.type === "company" ? "sidebar3-company-analysis" : "website-analysis"}
                        size="xs"
                        iconColor={isDisabled ? colorsPalettes.carbon[200] : colorsPalettes.carbon[250]}
                    />
                    <Text
                        color={isDisabled ? colorsPalettes.carbon[200] : colorsPalettes.carbon[250]}
                        fontVariant="body2"
                        cursor="pointer"
                    >
                        {capitalize(translate(data.type === "company" ? "common.company" : "common.website"))}
                    </Text>
                </Flex>,
            ]}
        />
    );
};

export default RecentItem;
